import { lazy, Suspense } from "react";
import Layout from "@/components/Layout";
import PageMeta from "@/components/PageMeta";
import HeroSection from "@/components/HeroSection";
import USPBar from "@/components/USPBar";
import ProductGrid from "@/components/ProductGrid";

// Lazy-load below-fold sections

const ExploreSection = lazy(() => import("@/components/ExploreSection"));
const BlogSection = lazy(() => import("@/components/BlogSection"));
const ReviewsSection = lazy(() => import("@/components/ReviewsSection"));
const InstagramCarousel = lazy(() => import("@/components/InstagramCarousel"));
const NewsletterSection = lazy(() => import("@/components/NewsletterSection"));

const SectionFallback = () => (
  <div className="py-20 flex items-center justify-center">
    <div className="w-6 h-6 border-2 border-border border-t-foreground rounded-full animate-spin" />
  </div>
);

const Index = () => {
  return (
    <Layout showStickyBar>
      <PageMeta
        title="Hand-Crocheted Statement Bags Made in Amsterdam"
        description="Discover NOTT's hand-crocheted statement bags, made to order in Amsterdam. Limited slow fashion pieces designed to stand out. 100% handmade, one of a kind."
        canonical="/"
      />
      <HeroSection />
      <USPBar />
      <ProductGrid />
      <Suspense fallback={<SectionFallback />}>
        <ExploreSection />
      </Suspense>
      <Suspense fallback={<SectionFallback />}>
        <BlogSection />
      </Suspense>
      <Suspense fallback={<SectionFallback />}>
        <ReviewsSection />
      </Suspense>
      <Suspense fallback={<SectionFallback />}>
        <InstagramCarousel />
      </Suspense>
      <Suspense fallback={<SectionFallback />}>
        <NewsletterSection />
      </Suspense>
    </Layout>
  );
};

export default Index;
